export default "__VITE_ASSET__5ba70e7c__"